import { SessionStateHelper } from './session-state.helper';
import { SelectionSummaryHelper } from '../content/selection-summary.helper';
import * as _ from 'lodash';

export class Step2ProcessorHelper {
  static processStep2Response(comp: any, opData: any, promptResult: any, preventScroll: boolean = false, targetBlock?: any) {
    if (targetBlock) {
      targetBlock.isAnalysisSwitching = false;
    } else {
      comp.isAnalysisSwitching = false;
    }

    // Update global state
    comp.promptData = promptResult;
    comp.isTotalBase = promptResult.isTotalBase ?? false;
    comp.selectedWeight = promptResult.weight || promptResult.Weight || comp.selectedWeight;
    if (comp.WeightDropDownList && comp.WeightDropDownList.length > 0) {
      const matchedWeight = comp.WeightDropDownList.find((w: any) => w.responseCode === comp.selectedWeight);
      comp.DefaultWeight = matchedWeight ? matchedWeight.Label : (comp.selectedWeight === 'Unweighted' ? 'Total Population' : comp.selectedWeight);
    } else {
      comp.DefaultWeight = comp.selectedWeight === 'Unweighted' ? 'Total Population' : comp.selectedWeight;
    }
    comp.isBrandAnalysis = (comp.mcode === 2);
    comp.is_sigtesting = (comp.mcode === 2 || comp.mcode === 3);
    comp.isSig = (comp.mcode === 2 || comp.mcode === 3);
    comp.arktabaccess = false;

    // Store payloads for persistence/sig-testing
    if (comp.mcode === 3 && opData.crosstab_payload) {
      comp.lastCrosstabPayload = opData.crosstab_payload;
    } else if (comp.mcode === 1) {
      comp.lastSnapshotPayload = opData.snapshot_payload || opData;
    } else if (comp.mcode === 2) {
      const bPayload = opData.brand_analysis_payload || opData.brand_anlysis_payload || comp.chatPayload;
      comp.lastBrandAnalysisPayload = bPayload;
      // Store original pipe strings from chatPayload for redirect Level0/Level1 derivation
      comp.lastBrandAnalysisOriginalPipes = {
        row: comp.chatPayload?.row || [],
        column: comp.chatPayload?.column || [],
        row_nesting: comp.chatPayload?.row_nesting || [],
        column_nesting: comp.chatPayload?.column_nesting || [],
        filters: comp.chatPayload?.filters || {}
      };
    }

    // Bundle trendline/customization data
    if (opData.response_payload_trendline) comp.currentRowPayloadTrendline = opData.response_payload_trendline;
    if (opData.trendline_response) comp.currentTrendlineResponse = opData.trendline_response;
    if (opData.customization_Properties_trendline) comp.currentCustomizationTrendline = opData.customization_Properties_trendline;

    // Trigger UI update through config service
    const outputResponse = opData.response || opData;
    comp._configService.outputSnapshotData = outputResponse;

    // Ensure we capture the *correct* active block for fresh questions
    // Since selectedMessageId is not updated until AFTER saveChatResponse completes,
    // prioritizing `isTemp` guarantees we bind data to the new block instead of overwriting the previous one.
    if (!targetBlock) {
      targetBlock = comp.chatPreviewBlocks.find((b: any) => b.isTemp);
    }
    if (!targetBlock) {
      targetBlock = comp.chatPreviewBlocks.find((b: any) => b.messageId === comp.selectedMessageId);
    }

    if (targetBlock?.messageId) {
      comp.selectedMessageId = targetBlock.messageId;
    }

    // Exact same process as normal flow:
    // 1. Reset states
    comp.resetChartStates(comp.mcode === 1 ? undefined : 'table');
    if (targetBlock) {
      comp.resetChartStates(comp.mcode === 1 ? undefined : 'table', targetBlock);
    }

    if (comp.mcode === 1) {
      comp.snapshotConfiguration = comp.promptData;
      comp.showSnapshot = true;
      comp.displayTable = false;
      comp.isDiagnostic = false;

      if (outputResponse.Data) {
        const opDataParsed = typeof outputResponse.Data === 'string' ? JSON.parse(outputResponse.Data) : outputResponse.Data;
        comp.MainResult = opDataParsed;
        comp.OutputData = opDataParsed.sort((a: any, b: any) => a.widgetNumber - b.widgetNumber);
        comp._configService.standardSnapOutputData = comp.OutputData;

        // RECONSTRUCT FILTERED WIDGET DATA FOR POPUP COMPATIBILITY
        const sortedOPdata = comp.OutputData;
        let selectedWidget: any = null;
        const currentQuestionText = (targetBlock?.question || comp.currentQuestion || '').toLowerCase();
        const uniqueWidgets = _.uniqBy(sortedOPdata, 'widgetNumber');

        if (currentQuestionText) {
          selectedWidget = uniqueWidgets.find((widget: any) =>
            currentQuestionText.includes(widget.widgetName.toLowerCase())
          );
        }

        if (!selectedWidget) {
          const snapConfigStr = comp.promptData?.getSnapshotConfiguration || targetBlock?.analyticalData?.member_responses?.snapshot?.getSnapshotConfiguration;
          let snapConfig: any = null;
          if (snapConfigStr) {
            try { snapConfig = typeof snapConfigStr === 'string' ? JSON.parse(snapConfigStr) : snapConfigStr; } catch (e) { }
          }

          const targetWidgetID = snapConfig?.Widget_ID || snapConfig?.widget_id
            || comp.promptData?.Widget_ID || comp.promptData?.widget_id
            || comp.promptData?.getSnapshotOutput?.Widget_ID || comp.promptData?.getSnapshotOutput?.widget_id
            || targetBlock?.analyticalData?.Widget_ID || targetBlock?.analyticalData?.widget_id
            || targetBlock?.analyticalData?.GetCustomSnapshotWidget?.Widget_ID || targetBlock?.analyticalData?.GetCustomSnapshotWidget?.widget_id;

          if (targetWidgetID) {
            selectedWidget = uniqueWidgets.find((widget: any) => String(widget.widgetNumber) === String(targetWidgetID));
          }
        }

        if (!selectedWidget) {
          selectedWidget = sortedOPdata[0];
        }

        if (selectedWidget) {
          const widgetFilteredRows = sortedOPdata.filter((item: any) => item.widgetNumber === selectedWidget.widgetNumber);
          const fallbackBaseValue = widgetFilteredRows.find((r: any) => r.answerUnweightedBase != null)?.answerUnweightedBase || 999;

          const uniqueMetrics = _.uniqBy(widgetFilteredRows, 'rowChild').map((item: any) => ({
            option: item.rowChild,
            selectOrder: 0,
            typeofmetric: 'METRIC',
            metric_group: '',
            data: widgetFilteredRows
              .filter((row: any) => row.rowChild === item.rowChild)
              .map((row: any) => {
                const colParts = (row.colChild || '').split('|');
                const specificCol = colParts.pop() || row.colChild;
                const parentLabel = colParts.pop() || 'Market';
                return {
                  data: row.answerWeightedShare,
                  data2: row.answerWeightedShareIndex,
                  lvl1Child: row.Level1ColChild,
                  colChild: `${parentLabel}|${specificCol}`,
                  rowChild: row.rowChild,
                  answerUnweightedBase: row.answerUnweightedBase || fallbackBaseValue,
                  answerWeightedShare: row.answerWeightedShare,
                  answerWeightedShareIndex: row.answerWeightedShareIndex,
                  CalculationType: row.CalculationType || 'share',
                  CalculationTypeIndex: row.CalculationTypeIndex || 'index',
                  Significance_Value: row.Significance_Answer || row.Significance_Total || row.Significance
                };
              })
          }));

          // Sort uniqueMetrics in descending order of values (matching normal flow behavior)
          uniqueMetrics.sort((a: any, b: any) => {
            const valA = a.data?.[0]?.data ?? 0;
            const valB = b.data?.[0]?.data ?? 0;
            return valB - valA; // Descending
          });

          const isBubble = selectedWidget.widgetChartType.toLowerCase().includes('bubble');

          comp.filteredWidgetData = {
            widgetchart_name: selectedWidget.widgetChartType,
            widget_name: selectedWidget.widgetName,
            previewChartPostion: selectedWidget.widgetNumber,
            customizationProperties: comp.getFormattedCustomProperties(selectedWidget.customization_Properties || opData.customization_Properties, selectedWidget.widgetChartType),
            quadrantText: opData.quadrantText ? JSON.stringify(opData.quadrantText) : null,
            metric: isBubble ? [
              { metric_option: 'XAxis Metric', metric_group: '', metric_value: [uniqueMetrics[0]] },
              { metric_option: 'YAxis Metric', metric_group: '', metric_value: [uniqueMetrics[1]] },
              { metric_option: 'ZAxis Metric', metric_group: '', metric_value: [uniqueMetrics[2]] }
            ] : [{
              metric_option: 'Data',
              metric_group: '',
              metric_value: uniqueMetrics
            }],
            response_payload_trendline: opData.response_payload_trendline,
            trendline_response: opData.trendline_response,
            response_payload: opData.response_payload
          };
          comp.filteredWidgetID = selectedWidget.widgetNumber;
        }

        const snapSummary = SelectionSummaryHelper.buildSnapshotSelectionSummary(comp, { promptData: comp.promptData });
        if (snapSummary) {
          comp.selectionSummary = snapSummary;
          comp._configService.selectionSummaryTextTitle = snapSummary;
          comp.GenerateSelectionSummary(snapSummary);
        } else {
          comp.SelectionSummary();
          comp.GenerateSelectionSummary();
        }
        comp.afterSubmit();
      }
    } else {
      comp.showSnapshot = false;
      comp.displayTable = true;
      comp.isDiagnostic = true;

      comp.LoadRibbonData(comp.filteredlist);

      if (outputResponse.Data) {
        comp.clearOutputDataObject(); // Reset table structure

        // Populate analytical context (dataObject) from metadata AFTER clearOutputDataObject to avoid wipeout
        SessionStateHelper.syncDataObjectFromPrompt(comp, promptResult);

        comp.CrossTabOutPutEntireData = typeof outputResponse.Data === 'string' ? JSON.parse(outputResponse.Data) : outputResponse.Data;
        comp.normalizeNestedChildFields(comp.CrossTabOutPutEntireData);

        comp.isTranspose = false;

        if (!comp.isTotal) {
          comp.CrossTabOutPutData = comp.CrossTabOutPutEntireData.filter((x: any) => !x.isTotal);
        } else {
          comp.CrossTabOutPutData = comp.CrossTabOutPutEntireData;
        }


        comp.BindTableOutput(comp.CrossTabOutPutData);
        comp.crossTabService.setCrossTabOuputData(comp.CrossTabOutPutData); // Update table component
        comp.sortOutputData();
        comp.isCreateBtnClick = true;
        comp.SelectionSummary();
        comp.GenerateSelectionSummary();
      }
    }

    if (targetBlock) {
      targetBlock.CrossTabOutPutData = comp.CrossTabOutPutData ? [...comp.CrossTabOutPutData] : [];
      targetBlock.OutputdataObject = comp.OutputdataObject ? JSON.parse(JSON.stringify(comp.OutputdataObject)) : null;

      // Reset block.builtTableData so getOutputData does not return stale Priority 1 data!
      targetBlock.builtTableData = null;

      targetBlock.mcode = comp.mcode;
      targetBlock.is_sigtesting = comp.is_sigtesting;
      targetBlock.is_Time_Period_Present = comp.is_Time_Period_Present;
      targetBlock.isIndex = comp.isIndex;
      targetBlock.isSig = comp.isSig;
      targetBlock.isTranspose = comp.isTranspose;
      const __ribbonFlags = comp.computeStudyRibbonFlags();
      targetBlock.is_TransposeBtn = comp.is_TransposeBtn || __ribbonFlags.transposeAvailable;
      targetBlock.is_confidenceLevel = (comp.is_confidenceLevel && comp.is_confidenceLevel.length)
        ? [...comp.is_confidenceLevel]
        : [...__ribbonFlags.confidenceLevels];
      targetBlock.SignificanceVsReference = comp.SignificanceVsReference;
      if (comp.selectionSummary && comp.selectionSummary.trim() !== '') {
        targetBlock.selectionSummary = comp.selectionSummary;
      }
      targetBlock.DefaultConfidenceLevel = comp.DefaultConfidenceLevel;
      targetBlock.DefaultSampleSize = comp.DefaultSampleSize;
      targetBlock.DefaultReferenceLevel = comp.DefaultReferenceLevel;
      targetBlock.selectedWeight = comp.selectedWeight;
      targetBlock.DefaultWeight = comp.DefaultWeight;
      console.log("--- CHATBOT LOG (buildChatOutputData) ---", "targetBlock.DefaultWeight:", targetBlock.DefaultWeight, "comp.DefaultWeight:", comp.DefaultWeight, "selectedWeight:", comp.selectedWeight);
      targetBlock.isTotalBase = comp.isTotalBase;
      targetBlock.isAnswerBase = comp.isAnswerBase;
      targetBlock.isSampleSize = comp.isSampleSize;
      targetBlock.isWeightedLabel = comp.isWeightedLabel;
      targetBlock.isTableClick = comp.isTableClick;
      targetBlock.isChartView = comp.isChartView;
      targetBlock.isVerticalGroupBarChartClick = comp.isVerticalGroupBarChartClick;
      targetBlock.isVerticalBarChartClick = comp.isVerticalBarChartClick;
      targetBlock.isVerticalStackChartClick = comp.isVerticalStackChartClick;
      targetBlock.isLineChartClick = comp.isLineChartClick;
      targetBlock.DefaultDataDropDown = comp.DefaultDataDropDown || 'Data';
      targetBlock.disableStackChart = comp.disableStackChart;
      targetBlock.disableLineChart = comp.disableLineChart;

      // Sync Ribbon List Properties to Target Block to ensure dropdowns work
      targetBlock.SampleSizeList = [...(comp.SampleSizeList || [])];
      targetBlock.WeightDropDownList = [...(comp.WeightDropDownList || [])];
      targetBlock.showStackTooltip = comp.showStackTooltip;
      targetBlock.showLineTooltip = comp.showLineTooltip;
      targetBlock.showBarTooltip = comp.showBarTooltip;
      targetBlock.showMainTooltip = comp.showMainTooltip;
      comp.updateChartDisablingFlags(targetBlock);
      // [REDIRECT ISOLATION] Save per-block payloads so redirectToModule uses the correct question's data
      if (comp.lastCrosstabPayload) targetBlock.crosstabPayload = comp.lastCrosstabPayload;
      if (comp.lastBrandAnalysisPayload) targetBlock.brandAnalysisPayload = comp.lastBrandAnalysisPayload;
      if (comp.lastBrandAnalysisOriginalPipes) targetBlock.brandAnalysisOriginalPipes = comp.lastBrandAnalysisOriginalPipes;
      if (comp.lastSnapshotPayload) targetBlock.snapshotPayload = comp.lastSnapshotPayload;
    }

    // Scroll to top of output area
    if (!preventScroll && comp.outputArea && comp.outputArea.nativeElement) {
      comp.outputArea.nativeElement.scrollTop = 0;
    }
  }

}
